module.exports = __webpack_public_path__ + "static/media/p3.54ea7532.png";